import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import FormError from 'components/FormError';
import Spinner from 'components/Spinner';
import SqlReportQueryTable from 'components/SqlReportQueryTable';
import withSqlReportQuery from 'decorators/withSqlReportQuery';
import { downloadSqlReportQuery, exportSqlReportQuery } from 'api';
import { handleSqlReportError } from 'helpers/errors';

class SqlReportQuery extends Component {
  state = {
    localLoading: false,
    error: '',
    successMsg: '',
    link: '',
  };

  setLoading = (value) => this.setState({ localLoading: value });

  handleDownload = async () => {
    const { id } = this.props.sqlReportQuery;
    try {
      this.setState({ localLoading: true });
      const response = await downloadSqlReportQuery(id);
      const href = URL.createObjectURL(response.data);
      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      document.body.appendChild(link);
      link.click();
      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      toast.success('Report query downloaded');
    } catch (e) {
      toast.error(handleSqlReportError(e));
    } finally {
      this.setState({ localLoading: false });
    }
  };

  handleGSheet = async () => {
    const { id } = this.props.sqlReportQuery;
    try {
      this.setState({ localLoading: true });
      const response = await exportSqlReportQuery(id);
      toast.success(
        () => (
          <div>
            <a
              href={response.data.report_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Google Sheet
            </a>
          </div>
        ),
        { autoClose: false },
      );
    } catch (e) {
      toast.error(handleSqlReportError(e));
    } finally {
      this.setState({ localLoading: false });
    }
  };

  handleSaveField = (key, value) => {
    const { sqlReportQuery, updateSqlReportQuery } = this.props;
    this.setLoading(true);
    updateSqlReportQuery(sqlReportQuery.id, { [key]: value })
      .then(() => {
        this.setLoading(false);
        toast.success('Query report updated');
      })
      .catch((e) => {
        if (e.errors) {
          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
        this.setLoading(false);
      });
  };

  render() {
    const { sqlReportQuery, loading, sqlReportId } = this.props;
    const { localLoading } = this.state;

    return (
      <div>
        <h1 className="mar-b">SQL Query Report</h1>
        <div className="flex-justify-space-between flex-align-center mar-b">
          <Link to={`/reporting/automated-reports/${sqlReportId}/view`}>
            &larr; Back to Automated Report
          </Link>
          <div className="d-flex">
            <button
              onClick={this.handleDownload}
              className="btn btn-default mar-r"
            >
              Download
            </button>
            <button onClick={this.handleGSheet} className="btn btn-default">
              Export to GSheets
            </button>
          </div>
        </div>
        <SqlReportQueryTable
          sqlReportQuery={sqlReportQuery}
          handleSaveField={this.handleSaveField}
        />
        <Spinner showLoader={loading || localLoading} />
      </div>
    );
  }
}

export default withSqlReportQuery(SqlReportQuery);
